import { createCancelable } from "app/pages/workspace/sales/helpers";
import type { IFetchService } from "app/services/fetchService";
import type { IntegrationStatusResponse } from "../../../components/types";

export type HubspotStatusServiceType = {
    getHubspotStatus(): Promise<IntegrationStatusResponse>;
    syncHubspot(): Promise<unknown>;
    disconnectHubspot(): Promise<unknown>;
};

export const hubspotStatusService = (fetchService: IFetchService): HubspotStatusServiceType => ({
    getHubspotStatus: createCancelable((signal: AbortSignal): Promise<IntegrationStatusResponse> => {
        return fetchService.get(`sales-api/hubspot/status`, undefined, {
            cancellation: signal,
        });
    }),
    disconnectHubspot: createCancelable((signal: AbortSignal): Promise<unknown> => {
        return fetchService.get(`sales-api/sw-connector/hubspot/disconnect`, undefined, {
            cancellation: signal,
        });
    }),
    syncHubspot: createCancelable((signal: AbortSignal): Promise<unknown> => {
        return fetchService.get(`sales-api/sw-connector/hubspot/sync`, undefined, {
            cancellation: signal,
        });
    }),
});
